import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    // URL: 'http://localhost/smartasystem.dev/wp-json/wp/v2/'
    URL: 'https://www.smartasystem.se/backend/wp-json/wp/v2/',
    URLJSON: 'https://www.smartasystem.se/driftstatus/',
    darkTheme: false
  },
  mutations: {
    SET_THEME(state, status){
      if(state.darkTheme){
        state.darkTheme = false;
      } else {
        state.darkTheme = true;
      }
  },
  },
  actions: {}
});
